<ion-card class="tarjeta-metrica-reporte">
  <ion-card-header>
    <div class="cabecera-metrica">
      <ion-card-title>{{ titulo }}</ion-card-title>
      <div class="header-acciones">
        <ion-button
          *ngIf="infoText"
          fill="clear"
          size="small"
          class="boton-informacion"
          [id]="'info-popover-' + id"
          aria-label="Información">
          <ion-icon slot="icon-only" name="information-circle-outline"></ion-icon>
        </ion-button>
        <ion-popover *ngIf="infoText" [trigger]="'info-popover-' + id" triggerAction="click" class="popover-informacion-tarjeta">
          <ng-template>
            <div class="popover-informacion">
              <p>{{ infoText }}</p>
            </div>
          </ng-template>
        </ion-popover>
        <ion-button *ngIf="puedeExportar"
          class="boton-exportar-csv"
          fill="outline"
          color="primary"
          size="small"
          [disabled]="cargando || exportandoCsv"
          (click)="onExportarCsv()"
          aria-label="Descargar CSV">
          <ion-icon slot="start" name="document-text-outline"></ion-icon>
          csv
        </ion-button>
      </div>
    </div>
  </ion-card-header>

  <ion-card-content>
    <ng-container *ngIf="cargando; else contenidoCargado">
      <div class="cargando-metrica">
        <ion-spinner name="crescent" color="medium"></ion-spinner>
      </div>
    </ng-container>

    <ng-template #contenidoCargado>
      <div class="valor-metrica">{{ valor }}</div>
      <div class="pie-metrica" *ngIf="desgloses.length == 0">
        <p class="detalle-metrica" *ngIf="detalle">{{ detalle }}</p>
        <ion-icon
          class="icono-metrica"
          [name]="icono"
          [style.color]="colorIconoCustom"
          aria-hidden="true">
        </ion-icon>
      </div>
      <div class="seccion-desglose" *ngIf="desgloses.length > 0">
        <p class="detalle-metrica" *ngIf="detalle">{{ detalle }}</p>
        <div class="fila-genero" *ngFor="let item of desgloses">
          <div class="etiqueta-valor">
            <span class="etiqueta">{{ item.etiqueta }}:</span>
            <span class="valor-genero">{{ item.valor }}</span>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template>
    
    </ng-template>
  </ion-card-content>
</ion-card>
